<template>
  <div>
    <v-tabs v-model="currentView" color="white" :slider-color="$vuetify.theme.primary">
      <v-tab
        :key="'seminar-management'"
        :to="{ name: 'seminar-management' }"
        ripple
        :href="'#seminar-management'"
      >
        {{ $t('seminar_management') }}
      </v-tab>
      <v-tab :key="'booking-list'" :to="{ name: 'booking-list' }" ripple :href="'#booking-list'">
        {{ $t('booking_list') }}
      </v-tab>
    </v-tabs>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      currentView: 'seminar-management'
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/Aira/MainMenu.vue